<mat-form-field appearance="outline" class="operator-part">
  <mat-select [(value)]="selectedUnitDisplay" (selectionChange)="onSelectionChange($event.value)">
    <mat-option *ngFor="let unit of allowedUnits" [value]="unit.getDisplay()">
      {{ unit.display }}
    </mat-option>
  </mat-select>
</mat-form-field>
